import React, { Component } from "react";
import { Helmet } from "react-helmet";
import usermanualfile from './file/PrivaySaferII_UserManual.pdf';

class UserManual extends Component {

    render() {

        let pageTitle = this.props.lang == 'en' ? "User Manual" : "Οδηγιες Χρησης";
        let manuaInstr = this.props.lang == 'en' ? "You can also find instruction on how to use the plugin " : "Μπορείτε να βρείτε και τις οδηγίες χρήσης της επέκτασης φυλλομετρητή "
        let manualInstrHere = this.props.lang == 'en' ? "here" : "εδώ"

        return (



            <section className="page-section userManual" id="userManual">
                <Helmet>
                    <meta charset="utf-8" />
                    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
                    <meta name="description" content="" />
                    <meta name="author" content="" />
                    <title>PrivacySaferIII</title>

                    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.4.1/jquery.easing.min.js"></script>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script>
                    <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.bundle.min.js"></script>
                    <script src="https://use.fontawesome.com/releases/v5.12.1/js/all.js" crossorigin="anonymous"></script>


                    <link href="https://fonts.googleapis.com/css?family=Montserrat:400,700" rel="stylesheet" type="text/css" />
                    <link href="https://fonts.googleapis.com/css?family=Lato:400,700,400italic,700italic" rel="stylesheet"
                        type="text/css" />
                </Helmet>

                <div className="container">

                    <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0"><label className="lang"
                        key="userManualTitle">{pageTitle}</label></h2>

                    <div className="divider-custom">
                        <div className="divider-custom-line"></div>
                        <div className="divider-custom-icon"><i className="fas fa-book"></i></div>
                        <div className="divider-custom-line"></div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <iframe width="420" height="315" src="https://www.youtube.com/embed/gyHkKqIDeVE">
                                </iframe>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <iframe width="420" height="315" src="https://www.youtube.com/embed/jFyIy-KUoBM">
                                </iframe>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <iframe width="420" height="315" src="https://www.youtube.com/embed/pVadFGrlW1M">
                                </iframe>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <iframe width="420" height="315" src="https://www.youtube.com/embed/WyPaTj6rlmY">
                                </iframe>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 ml-auto">
                            <p className="lead">
                                <label className="lang" key='UserManualTextPartOne'>{manuaInstr}
                                </label> <a href={usermanualfile} target="_blank"><span className="lang"
                                    key="UserManualTextPartTwo">{manualInstrHere}.</span></a>
                            </p>
                        </div>
                    </div>
                </div>

            </section>
        );
    }
}

export default UserManual;